export { core, get, createToken, createCoreElement } from './system';